/**
 * Billing Service — Org-facing billing endpoint
 * GET /api/v1/billing/me → current subscription, seat estimate, invoice history
 */

import apiClient from './apiClient';
import type { BillingMeResponse } from '@upskill/shared';

export const getMyBilling = async (): Promise<BillingMeResponse> => {
  const response = await apiClient.get<{ success: boolean; data: BillingMeResponse }>(
    '/api/v1/billing/me',
  );
  return response.data.data;
};

const billingService = {
  getMyBilling,
};

export default billingService;
